export default "__VITE_ASSET__DQ_yF9Q1__"